import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './initStore';
import type { IMessageDialogTypes } from '../components/Layout/Dialogs/DialogConfig';

export interface IMessageDialogConfig {
    message?: string;
    title: string;
    type: IMessageDialogTypes;
}

export interface IMessageDialogState {
    config: IMessageDialogConfig | null;
}

export const messageDialogSlice = createSlice({
    name: 'messageDialog',
    initialState: { config: null } as IMessageDialogState,
    reducers: {
        update: (state, action: PayloadAction<IMessageDialogConfig | null>) => {
            state.config = action.payload;
        },
    },
});

export const { update } = messageDialogSlice.actions;
export const messageDialogConfig = (state: IGlobalStoreReducers) => state.messageDialog.config;

export default messageDialogSlice.reducer;
